import usersService from 'services/extusers.service';
import types from '../actionTypes';


export const getUsersForSubject = (subjectId) => (dispatch, getState) => {
    if (getState().extUsersData.isFetchingSubjectUsers) {
        return Promise.reject();
    }

    dispatch({
        type: types.PARKING_SUBJECT_EXT_USERS_FETCH_REQUEST,
    });

    return usersService.getUsersForSubject(subjectId)
        .then((parkingUsers) => {
            dispatch({
                type: types.PARKING_SUBJECT_EXT_USERS_FETCH_SUCCESS,
                payload: {parkingUsers},
            });

            return parkingUsers;
        })
        .catch((error) => {
            dispatch({
                type: types.PARKING_SUBJECT_EXT_USERS_FETCH_FAIL,
                payload: {error},
            });

            throw error;
        });
};

export const fetchAllUsers = () => (dispatch, getState) => {
    if (getState().extUsersData.isFetchingParkingList) {
        return Promise.reject();
    }

    dispatch({
        type: types.PARKING_EXT_USERS_FETCH_ALL_REQUEST,
    });

    return usersService.getUsersAll()
        .then((parkingUsers) => {
            dispatch({
                type: types.PARKING_EXT_USERS_FETCH_ALL_SUCCESS,
                payload: {parkingUsers},
            });

            return true;
        })
        .catch((error) => {
            dispatch({
                type: types.PARKING_EXT_USERS_FETCH_ALL_FAIL,
                payload: {error},
            });

            throw error;
        });
};

export const fetchAllUsersByRole = (roleId) => (dispatch, getState) => {
    if (getState().extUsersData.isFetchingRoleUser) {
        return Promise.reject();
    }

    dispatch({
        type: types.PARKING_EXT_ROLE_FETCH_ALL_REQUEST,
    });

    return usersService.getUsersAllByRole(roleId)
        .then((roleUsers) => {
            dispatch({
                type: types.PARKING_EXT_ROLE_FETCH_ALL_SUCCESS,
                payload: {roleUsers: roleUsers},
            });

            return true;
        })
        .catch((error) => {
            dispatch({
                type: types.PARKING_EXT_ROLE_FETCH_ALL_FAIL,
                payload: {error},
            });

            throw error;
        });
};


export const createUser = (user) => (dispatch, getState) => {
    if (getState().extUsersData.isCreating) {
        return;
    }

    dispatch({
        type: types.PARKING_EXT_USER_CREATE_REQUEST,
    });

    return usersService.createUser(user)
        .then(() => {
            dispatch({
                type: types.PARKING_EXT_USER_CREATE_SUCCESS,
                payload: {user: user},
            });

            return true;
        })
        .catch((error) => {
            dispatch({
                type: types.PARKING_EXT_USER_CREATE_FAIL,
                payload: {error},
            });

            throw error;
        });
};

export const updateUser = (user) => (dispatch, getState) => {
    if (getState().extUsersData.isUpdating) {
        return;
    }

    dispatch({
        type: types.PARKING_EXT_USER_UPDATE_REQUEST,
    });

    return usersService.updateUser(user)
        .then(() => {
            dispatch({
                type: types.PARKING_EXT_USER_UPDATE_SUCCESS,
                payload: {user: user},
            });
            return true;
        })
        .catch((error) => {
            dispatch({
                type: types.PARKING_EXT_USER_UPDATE_FAIL,
                payload: {error},
            });

            throw error;
        });
};

export const updateUserState = (userId, active) => (dispatch, getState) => {
    if (getState().extUsersData.isUpdating) {
        return Promise.reject();;
    }

    dispatch({
        type: types.PARKING_EXT_USER_UPDATE_STATE_REQUEST,
    });

    return usersService.updateUserState(userId, active)
        .then(() => {
            dispatch({
                type: types.PARKING_EXT_USER_UPDATE_STATE_SUCCESS,
                payload: {},
            });
            return true;
        })
        .catch((error) => {
            dispatch({
                type: types.PARKING_EXT_USER_UPDATE_STATE_FAIL,
                payload: {error},
            });

            throw error;
        });
};

export const synchUser = (user, parkingIds) => (dispatch, getState) => {
    if (getState().extUsersData.isUpdating) {
        return;
    }

    dispatch({
        type: types.PARKING_EXT_USER_SYNCH_REQUEST,
    });

    return usersService.synchUser(user, parkingIds)
        .then(() => {
            dispatch({
                type: types.PARKING_EXT_USER_SYNCH_SUCCESS,
                payload: {},
            });
            return true;
        })
        .catch((error) => {
            dispatch({
                type: types.PARKING_EXT_USER_SYNCH_FAIL,
                payload: {error},
            });

            throw error;
        });
};